export default "__VITE_ASSET__BeEnk6u1__"